import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import {  selectIsLoggedIn } from '../../features/auth/auth.slice';
import { useAividUrlParams } from '../../hooks';
import { generateHackSearchUrl } from '../../common/helper';
import { useSelector } from 'react-redux';

export const PrivateRoute = ({ component,  ...rest }) => {
    const isAuthenticated = useSelector(selectIsLoggedIn)
  const routeComponent = (props) => {
    const forRedirectionSearchParams = generateHackSearchUrl(props.location);
    
    return isAuthenticated ? (
      React.createElement(component, props)
    ) : (
      <Redirect
        to={{
          pathname: '/auth/login',
          search: forRedirectionSearchParams,
          state: { from: props.location },
        }}
      />
    );
  };
  return <Route {...rest} render={routeComponent} />;
};

export const LoginUserRoute = ({ component, ...rest }) => {
  const loggedIn = useSelector(selectIsLoggedIn);

  let forRedirectionSearchParams = useAividUrlParams();
  if (!forRedirectionSearchParams.pathname || forRedirectionSearchParams.pathname === '/auth/login') {
    forRedirectionSearchParams.pathname = '/inspection-report';
  }
  const routeComponent = (props) => {
    return loggedIn ? (
      <Redirect to={{ ...forRedirectionSearchParams, state: { from: props.location } }} />
    ) : (
      React.createElement(component, props)
    );
  };
  return <Route {...rest} render={routeComponent} />;
};
